import { notification as antNotification } from 'antd';

class NotificationService {
  constructor() {
    this.notification = null;
  }

  setNotification(notification) {
    this.notification = notification;
  }

  success(config) {
    if (this.notification) {
      this.notification.success(config);
    } else {
      antNotification.success(config);
    }
  }

  error(config) {
    if (this.notification) {
      this.notification.error(config);
    } else {
      antNotification.error(config);
    }
  }

  warning(config) {
    if (this.notification) {
      this.notification.warning(config);
    } else {
      antNotification.warning(config);
    }
  }

  info(config) {
    if (this.notification) {
      this.notification.info(config);
    } else {
      antNotification.info(config);
    }
  }

  destroy(key) {
    if (this.notification) {
      this.notification.destroy(key);
    } else {
      antNotification.destroy(key);
    }
  }
}

export default new NotificationService();
